import { render, staticRenderFns } from "./ProyekDashboard.vue?vue&type=template&id=0468e748"
import script from "./ProyekDashboard.vue?vue&type=script&lang=js"
export * from "./ProyekDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports